import Layout from '../views/layout/Layout'

export default {
  path: '/questionnaire',
  component: Layout,
  redirect: '/questionnaire/word',
  name: 'questionnaire',
  meta: {title: '问卷数据', icon: 'data-center'},
  children: [
    {
      path: 'word',
      name: 'word',
      component: () => import('@/views/questionnaire/word.vue'),
      meta: {title: '检测数据 ', icon: 'word'}
    },
    {
      path: 'report',
      name: 'report',
      component: () => import('@/views/questionnaire/report/index.vue'),
      meta: {title: '查看报告与问卷详情', icon: 'store-list'},
      hidden: true
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/questionnaire.js